// @ai-generated 2026-08-21T00:00:00Z by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { readUnsuccessfulMessages } from '@utils/toolCallEnvelope';
import type { ReactNode } from 'react';
import classes from './ToolCallCardShell.module.css';
import { ToolCallFailureReasons } from './ToolCallFailureReasons';
import toneClasses from './toolCallTone.module.css';
import type { ToolCallState } from './toolCallStatus';

interface ToolCallCardShellProps {
    title: string;
    /** One line under the title, stating what the call did. */
    summary?: ReactNode;
    state: ToolCallState;
    /** What the call produced, rendered for reading rather than for inspection. */
    body?: ReactNode;
    /** The raw result, read only to explain a failure. */
    result?: unknown;
}

/**
 * The frame every in-chat tool call shares. A successful call's payload stays out of the
 * transcript — that is for the tool call sidebar and the command logs.
 *
 * Failure reasons are rendered here rather than per card: naming a tool takes it off the wildcard
 * fallback, so a card that forgot them would make a named tool's failures less legible.
 */
export function ToolCallCardShell({ title, summary, state, body, result }: ToolCallCardShellProps) {
    const reasons = state.isFailed && body === undefined ? readUnsuccessfulMessages(result) : [];
    const shownBody = body ?? (reasons.length > 0 ? <ToolCallFailureReasons reasons={reasons} /> : undefined);

    return (
        <div className={classes.wrapper}>
            <div className={`${classes.card} ${toneClasses[state.tone]}`}>
                <div className={classes.header}>
                    <div className={classes.headerLeft}>
                        <span className={classes.statusDot} />
                        <div className={classes.titleBlock}>
                            <span className={classes.title}>{title}</span>
                            {summary !== undefined && <span className={classes.summary}>{summary}</span>}
                        </div>
                    </div>
                    <span className={classes.statusPill}>{state.statusLabel}</span>
                </div>
                {shownBody !== undefined && <div className={classes.body}>{shownBody}</div>}
            </div>
        </div>
    );
}
